import { render, staticRenderFns } from "./combinations.vue?vue&type=template&id=c3c6b9e0&scoped=true&"
import script from "./combinations.vue?vue&type=script&lang=js&"
export * from "./combinations.vue?vue&type=script&lang=js&"
import style0 from "./combinations.vue?vue&type=style&index=0&id=c3c6b9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c6b9e0",
  null
  
)

export default component.exports